import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';

import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';
import { ProductLineNameCodesTypes } from '@ordersnproducts/modules/shared/constants/product-lines-codes';

@Injectable()
export class AdjustmentOrderFeature implements IFlagFeature {
  name = Features.AdjustmentOrder;

  public isEnabled(container: IToggleContainer, params: { businessLineCode: ProductLineNameCodesTypes }): boolean {
    return (
      params && params.businessLineCode && container[this.name].getValue().split(' ').includes(params.businessLineCode)
    );
  }
}
